import { useQuery } from "@tanstack/react-query";
import { oauthApi } from "@/api/billing";
import { IcoGitHub, IcoGoogle } from "@/components/icons";
import { AuthDivider } from "@/components/AuthShell";

const PROVIDERS: { id: string; label: string; icon: React.ReactNode }[] = [
  { id: "github", label: "GitHub", icon: <IcoGitHub size={14} /> },
  { id: "google", label: "Google", icon: <IcoGoogle size={14} /> },
];

// Horizontal OAuth row with brand icons (GitHub then Google), matching the
// design. The "OR EMAIL" divider is rendered here, right after the buttons, so
// that when no provider is enabled the whole block (buttons AND divider)
// disappears together -- otherwise the divider is left orphaned above the
// email form.
export function OAuthButtons() {
  const q = useQuery({
    queryKey: ["oauth-providers"],
    queryFn: oauthApi.listProviders,
    staleTime: 5 * 60_000,
  });
  const enabled = q.data?.enabled ?? [];
  const shown = PROVIDERS.filter((p) => enabled.includes(p.id));
  if (shown.length === 0) return null;
  return (
    <>
      <div className="mb-5 flex gap-2">
        {shown.map((p) => (
          <a
            key={p.id}
            href={`/api/v1/auth/oauth/${p.id}/start`}
            className="flex flex-1 items-center justify-center gap-2 rounded-[var(--radius-sm)] border border-ef-border bg-ef-panel2 px-3 py-2 text-sm text-ef-textDim transition-colors hover:border-ef-accent hover:bg-ef-panel3 hover:text-ef-text"
          >
            {p.icon} {p.label}
          </a>
        ))}
      </div>
      <AuthDivider />
    </>
  );
}
